import { get, post } from "../../utils/axiosInstance";

const BASE_URL = "/rest/inventory/credit_notes";

export const createCreditNote = (data) => {
  const url = `${BASE_URL}/`;
  return post(url, data);
};

export const fetchCreditNote = (id) => {
  const url = `${BASE_URL}/${id}/`;
  return get(url);
};

export const fetchCreditNotes = (page, invoiceNumber = null, creditNoteNumber = null, creditNoteDate = null, vendor = null) => {
  let url = `${BASE_URL}/?page=${page}`;
  if (invoiceNumber) url += `&invoice__invoice_number=${invoiceNumber}`;
  if (creditNoteNumber) url += `&credit_note_number=${creditNoteNumber}`;
  if (creditNoteDate) url += `&created_at=${creditNoteDate}`;
  if (vendor) url += `&invoice__vendor=${vendor}`;
  return get(url);
};

export const getCreditNoteBoxes = (iId) => {
  const url = `/rest/inventory/invoice/${iId}/credit_note_boxes`;
  return get(url);
};
